import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/** Phase 2B — Furmais Genie empty state.
 *
 * Drops into any "list is empty" surface where the existing flow is safe to
 * decorate (Projects list, Sample Outputs, etc). Never replaces a real
 * error UI — only used when the API legitimately returns zero items.
 */
export default function GenieEmpty({
    title = "No Furmais yet.",
    subtitle = "Start your first one.",
    ctaLabel = "Start a Project",
    ctaTo = "/projects/new",
    onCta,
    className = "",
    "data-testid": testid = "genie-empty",
}) {
    const Btn = (
        <span className="btn-accent text-sm inline-flex">
            {ctaLabel} <ArrowRight className="w-4 h-4" />
        </span>
    );
    return (
        <div className={`text-center py-14 px-6 ${className}`} data-testid={testid}>
            <div className="relative inline-block">
                <div className="absolute inset-0 rounded-full bg-[#FF4400]/15 blur-2xl genie-pulse" aria-hidden="true" />
                <img
                    src="/genie/genie.png"
                    alt="Furmais AI Genie mascot"
                    loading="lazy"
                    className="relative w-28 h-28 object-contain mx-auto"
                />
            </div>
            <h3 className="font-display text-xl text-white mt-4">{title}</h3>
            <p className="text-sm text-zinc-400 mt-1.5 max-w-sm mx-auto">{subtitle}</p>
            <div className="mt-5">
                {onCta ? (
                    <button type="button" onClick={onCta} data-testid={`${testid}-cta`}>{Btn}</button>
                ) : (
                    <Link to={ctaTo} data-testid={`${testid}-cta`}>{Btn}</Link>
                )}
            </div>
        </div>
    );
}
